const transformLocation = (v) => {
	const { location, seoLocation } = v;
	return {
		...location,
		preferredPlaceName: seoLocation?.city || location?.subLocality || location?.city
	};
};

export default transformLocation;
